var $98fe636f19612bd9$exports = {};
'use strict';
class $98fe636f19612bd9$var$ThemeSaveException extends Error {
    constructor(){
        super('Failed to save theme to localstorage');
    }
}
const $98fe636f19612bd9$var$STORAGE_KEY = 'bitwise-theme-preference';
const $98fe636f19612bd9$var$THEMES = Object.freeze({
    LIGHT: 'light',
    DARK: 'dark'
});
function $98fe636f19612bd9$var$is_valid_theme(value) {
    return value === $98fe636f19612bd9$var$THEMES.LIGHT || value === $98fe636f19612bd9$var$THEMES.DARK;
}
function $98fe636f19612bd9$var$change_theme(theme) {
    return theme === $98fe636f19612bd9$var$THEMES.DARK ? $98fe636f19612bd9$var$THEMES.LIGHT : $98fe636f19612bd9$var$THEMES.DARK;
}
const $98fe636f19612bd9$var$load = ()=>{
    try {
        const value = localStorage.getItem($98fe636f19612bd9$var$STORAGE_KEY);
        return $98fe636f19612bd9$var$is_valid_theme(value) ? value : null;
    } catch  {
        return null;
    }
};
const $98fe636f19612bd9$var$save = (theme)=>{
    try {
        localStorage.setItem($98fe636f19612bd9$var$STORAGE_KEY, theme);
    } catch  {
        new $98fe636f19612bd9$var$ThemeSaveException();
    }
};
const $98fe636f19612bd9$var$media = window.matchMedia('(prefers-color-scheme: dark)');
const $98fe636f19612bd9$var$current = ()=>{
    return $98fe636f19612bd9$var$media.matches ? $98fe636f19612bd9$var$THEMES.DARK : $98fe636f19612bd9$var$THEMES.LIGHT;
};
const $98fe636f19612bd9$var$on_change = (handler)=>{
    $98fe636f19612bd9$var$media.addEventListener('change', (event)=>{
        handler(event.matches ? $98fe636f19612bd9$var$THEMES.DARK : $98fe636f19612bd9$var$THEMES.LIGHT);
    });
};
const $98fe636f19612bd9$var$root = document.documentElement;
const $98fe636f19612bd9$var$apply = (theme, with_transition)=>{
    if (with_transition) $98fe636f19612bd9$var$root.classList.add('theme-transition');
    $98fe636f19612bd9$var$root.setAttribute('data-theme', theme);
    if (with_transition) setTimeout(()=>$98fe636f19612bd9$var$root.classList.remove('theme-transition'), 300);
};
const $98fe636f19612bd9$var$theme_icons = {
    [$98fe636f19612bd9$var$THEMES.DARK]: '&#9789;',
    [$98fe636f19612bd9$var$THEMES.LIGHT]: '&#9728;'
};
const $98fe636f19612bd9$var$update_toggle = (theme)=>{
    const button = document.getElementById('theme-toggle');
    if (!button) return;
    const next = $98fe636f19612bd9$var$change_theme(theme);
    button.setAttribute('aria-label', `Switch to ${next} theme`);
    button.setAttribute('aria-pressed', String(theme === $98fe636f19612bd9$var$THEMES.DARK));
    button.innerHTML = $98fe636f19612bd9$var$theme_icons[theme];
};
let $98fe636f19612bd9$var$current_theme;
const $98fe636f19612bd9$var$start = ()=>{
    $98fe636f19612bd9$var$current_theme = $98fe636f19612bd9$var$load() || $98fe636f19612bd9$var$current();
    $98fe636f19612bd9$var$apply($98fe636f19612bd9$var$current_theme, false);
    $98fe636f19612bd9$var$update_toggle($98fe636f19612bd9$var$current_theme);
    $98fe636f19612bd9$var$on_change((theme)=>{
        if (!$98fe636f19612bd9$var$load()) {
            $98fe636f19612bd9$var$current_theme = theme;
            $98fe636f19612bd9$var$apply(theme, true);
            $98fe636f19612bd9$var$update_toggle(theme);
        }
    });
};
const $98fe636f19612bd9$var$toggle = ()=>{
    $98fe636f19612bd9$var$current_theme = $98fe636f19612bd9$var$change_theme($98fe636f19612bd9$var$current_theme);
    $98fe636f19612bd9$var$save($98fe636f19612bd9$var$current_theme);
    $98fe636f19612bd9$var$apply($98fe636f19612bd9$var$current_theme, true);
    $98fe636f19612bd9$var$update_toggle($98fe636f19612bd9$var$current_theme);
};
$98fe636f19612bd9$var$start();
const $98fe636f19612bd9$var$button = document.getElementById('theme-toggle');
$98fe636f19612bd9$var$button.addEventListener('click', ()=>{
    $98fe636f19612bd9$var$toggle();
});


//# sourceMappingURL=bitwise.84ac98a7.js.map
